import React from 'react';
import { isTelegramWebApp } from '../../utils/telegramUtils';
import WebLayout from '../layout/WebLayout';

const MiniAppSwitch = ({ MiniComponent, WebComponent, miniProps = {}, webProps = {}, noWebLayout = false }) => {
    const inMiniApp = isTelegramWebApp();
    if (inMiniApp && MiniComponent) return <MiniComponent {...miniProps} />;
    if (WebComponent && noWebLayout) return <WebComponent {...webProps} />;
    if (WebComponent) return <WebLayout><WebComponent {...webProps} /></WebLayout>;
    return null;
};

export default MiniAppSwitch;
